module.exports = __webpack_public_path__ + "static/media/fun9.4c1fd988.png";